export default "__VITE_ASSET__3YdoLukm__"